module.exports = __webpack_public_path__ + "img/onetwotree6.d7f7384d.jpg";